<style lang="scss" scoped>
    .module-section {
        font-size: 18px;

        .section-name {
            color: #4d8ab7;
            font-weight: 300;
            font-size: 1.1em;
        }
    }

    .modal-training-title {
        font-size: 2.0em;
        color: #fff;
    }

    .training-hr {
        margin-top: 5px;
        margin-bottom: 0.8em !important;
    }

    .font-size-3em {
        font-size: 3.0em;
    }

    .yanone {
        font-family: "Yanone Kaffeesatz", sans-serif;
    }

</style>


<template>
	<div>
        <BModal id="content-modal" ref="contentModal" 
            @hidden="onContentModalHidden"
            :header-class="'bg-'+moduleColor" 
            centered
            size="xl"
            hide-footer
            :static=true
        >
            <template slot="modal-header" >
                <span class="modal-training-title yanone" >{{ trainingTitle }}</span>
                <BButton-close class="font-size-3em" @click="$bvModal.hide('content-modal')"></BButton-close>
            </template>

            <template slot="default">
                <component :is="currentComponent"
                    :training-id="currentTrainingId"
                    :user="user"
                    @set-to-completed="enableBuildTheSkillsStepTwo"
                >
                	<template v-slot:instructions>
                        <p>Click Play to start the training. Just like in the provider account, you will be asked to pause to reflect and answer a couple questions along the way. However, at the end of the video, you do not need to write down the quiz code. This account does not offer knowledge quizzes, evaluations or certificates. These functions only exist in a Go NAPSACC child care provider account.</p>
                	</template>

                </component>
            </template>
        </BModal>


        <dashboard-tabs :modules="modules">
            <template #primary="{ module }">
                <div class='text-center pt-3'>
                    <p>This Provider Trainings page allows you to view the same trainings as child care providers so you may familiarize yourself with the content and decide which trainings you may want to recommend to child care providers. This page does not include knowledge quizzes, evaluations, or the ability to take attendance and therefore cannot generate certificates.</p>

                    <p><strong>Do not use this page to host trainings for child care providers.</strong></p>

                    <p>If you would like to deliver a training using the Go NAPSACC training videos you <strong><u>must</u></strong> login to a child care provider’s Go NAPSACC account.  This gives you access to the training videos, knowledge quizzes and evaluations.  The only way for child care providers to receive completion certificates and be included in any training reports is to complete a training in a Go NAPSACC child care provider account.</p>
            	</div>
            </template>

            <template #secondary="{ module }">
                <BContainer :class="'mx-0 p-4 border-'+ module.color +' border-top-0'">
                    <BRow cols="2">
                        <BCol v-for="training in trainingsInModule(module.id)" :key="training.id" class="module-section pb-5">
                            <BRow>
                                <BCol cols="4">
                                    <div class="section-image img-wrapper-green">
                                        <img :src="require('public@/images/summary/' + training.image_thumb)" class="w-100" />
                                    </div>
                                </BCol>
                                <BCol cols="8">
                                    <div class="section-name yanone"><a href="#" v-BModal.content-modal @click.prevent="setCurrentContent('panopto-video-embed', training.id)">{{training.title}}</a></div>
                                    <hr class="training-hr" />
                                    
                                	<BButton v-BModal.content-modal class="play-btn btn btn-orange-blue" @click="setCurrentContent('panopto-video-embed', training.id)">
                                		<i class="fa fa-play" aria-hidden="true"></i>
									</BButton>
                                </BCol>
                            </BRow>
                        </BCol>
                    </BRow>
                </BContainer>

                <div :class="'build-the-skills row container mx-0 p-4 border-'+ module.color +' border-top-0'" v-if="isBuildTheSkillsDisplayed(module.slug)">
                    <build-the-skills
                        :user="user"
                        @select-content="setCurrentBuildTheSkillsContent"
                        :step-two-enabled="isBuildTheSkillsStepTwoEnabled"
                    >
                    </build-the-skills>
                </div>
            </template>

        </dashboard-tabs>

	</div>	

</template>

<script>

	import ModuleIcon from '../ModuleIcon';
    import DashboardTabs from '../dashboard_tabs/DashboardTabs';
    import PanoptoVideoEmbed from './PanoptoVideoEmbed';
    import BuildTheSkills from '../BuildTheSkills/BuildTheSkills.vue';
    import BuildTheSkillsAssessment from './BuildTheSkillsAssessment.vue';
    import BuildTheSkillsVideo from './BuildTheSkillsVideo.vue';
    import BuildTheSkillsCertificate from './BuildTheSkillsCertificate.vue';
    import { mapState, mapGetters, mapMutations } from 'vuex';


    export default {
    	components: {
    		ModuleIcon,
			DashboardTabs,
			PanoptoVideoEmbed,
            BuildTheSkills,
            BuildTheSkillsAssessment,
            BuildTheSkillsVideo,
            BuildTheSkillsCertificate
    	},
    	props: {
            modules: {
                required: true,
                type: Array
            },
            user: {
                required: false,
                type: Object,
                default: null,
            },
    	},
    	data: () => {
    		return {
                currentTrainingId: null,
                currentComponent: null,
                // isBuildTheSkillsDisplayed: false,
                isBuildTheSkillsStepTwoEnabled: false,
    		};
    	},
    	methods: {
            initState() {
                let vm = this;

                axios.get('/provider-trainings/data' + (vm.programId ? "/program/" + vm.programId : ""))
                .then(response => {
                    let trainings = response.data.trainings; 
                    vm.initTrainings({trainings});
                });
            },
            setCurrentContent(component, trainingId) {
                this.currentComponent = component;
                this.currentTrainingId = trainingId;
                this.$refs.contentModal.show();
            },
            onContentModalHidden() {
                this.resetContent();
            },
            resetContent() {
                this.currentComponent = null;
                this.currentTrainingId = null;
            },
            setCurrentBuildTheSkillsContent(component, userId) {
                this.setCurrentContent(component, null);
            },
            hasRole(role) {
                return Auth.is(role);
            },
            isBuildTheSkillsDisplayed(module_slug) {
                return module_slug == "infant-and-child-physical-activity" &&
                    this.hasRole('ta-consultant');
            },
            enableBuildTheSkillsStepTwo() {
                this.isBuildTheSkillsStepTwoEnabled = true;
            },
            ...mapMutations({
                initTrainings: 'INIT_TRAININGS',
            })
    	},
    	computed: {
            currentTraining: function() {
                if(this.currentTrainingId) {
                    return this.trainings[this.currentTrainingId];
                }
                return null;
            },
            trainingTitle: function() {
                if(this.currentTraining) {
                    return this.currentTraining.title;
                } else {
                    return "Build the Skills";
                }
                return "Current Training";
            },
            moduleColor() {
                if(this.currentTraining && this.currentTraining.section && this.currentTraining.section.module) {
                   return this.currentTraining.section.module.color;
                } else {
                    return "primary";
                }
                return "white";
            },
            ...mapState([
                'trainings',
                'trainingSessions'
            ]),
            ...mapGetters([
                'trainingsInModule'
            ]),
    	},
        mounted: function() {
            this.initState();
        }
    }

	
</script>